import { render, staticRenderFns } from "./SubTitle2.vue?vue&type=template&id=058ae337&scoped=true"
import script from "./SubTitle2.vue?vue&type=script&lang=js"
export * from "./SubTitle2.vue?vue&type=script&lang=js"
import style0 from "./SubTitle2.vue?vue&type=style&index=0&id=058ae337&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058ae337",
  null
  
)

export default component.exports